export enum ECustomerMovementKey {
    INITIAL_BALANCE = 'initial_balance',
    NOTE = 'note',
    ORDER = 'order',
    PAYMENT = 'payment',
    PAYMENT_REFUND = 'payment_refund',
    DEBIT_CREDIT = 'debit_credit',

    // TODO: delete after process
    OTHER = 'other',
    DISCOUNT = 'discount',
    REFUND = 'refund',
}

export enum ECustomerMovementType {
    CREDIT = 1,
    DEBIT = 2
}
